import Toolbox from '../Toolbox/Toolbox'; 
import SC_ManageGate from './SC_ManageGate'; 
import WoocommerceAPI from '../IPSAPI/WoocommerceAPI'; 

const SidecartControl = {
  
  noticeElementRef: null, // Die Ref initialisieren
  shownMessages: {},
  serverproof: false,


  setNoticeElementRef: (element) => {
    // Die Ref auf das DOM-Element setzen
    SidecartControl.noticeElementRef = element;
  },




  checkSideCartConditions: ({ productId, producttyp, ipsproducttyp, button, settingsbox = null, cartslider_tmp = null, theme = null, cartItems = null, cartCount = null}) => {

    var addtocart_productid = parseInt(productId);

    let passed = {
      passed: true,
      passed_product: true,
      passed_cart: true,
    };



    //const cartItemsFromStorage = JSON.parse(localStorage.getItem('ips_cart_items')) || [];
    SidecartControl.serverproof = cartCount != null ? true : false;
    let { cart_amount } = SC_ManageGate.getDataForTheme(theme, SidecartControl.serverproof, cartItems);
   // console.log("Cart amount: ",cart_amount);
   // console.log("Cart Count Server ",cartCount);
    //const cartamount = cart_amount;
    const cartamount = cartCount != null ? cartCount : cart_amount;

    //console.log("Cart Amount  ",cartamount);
    //console.log("Cart Items  ",cartItems);
    //console.log("Producttyp base  ",producttyp);
    //console.log("Producttyp flags  ",ipsproducttyp);
    //console.log("Settingsbox  ",settingsbox);

   // if(cartamount !== 0 && Array.isArray(settingsbox)){
      if (cartamount !== 0 && settingsbox && typeof settingsbox === 'object') {

      //  console.log("Do the MAIN restriction check");

    //let noorderbumps_tmp = settingsbox[0]['ips-mb-cartgate-addon-noorderbump'];
    let noorderbumps_tmp = settingsbox['ips-mb-cartgate-addon-noorderbump'];
    //const controldirection = settingsbox[1]['ips-cartgate-settings-direction'];
    const controldirection = settingsbox['type'];

    let noorderbumps = noorderbumps_tmp === '1' ? true : false;

    let ORLABEL_PRODUCT = SC_ManageGate.getOrlabelFromSettingsbox_product(settingsbox);

    let ORLABEL_CART = SC_ManageGate.getOrlabelFromSettingsbox_cart(settingsbox);


    let ANDARRAY_PRODUCT = []; 
    let ANDARRAY_CART = [];

    if (Array.isArray(ORLABEL_PRODUCT)) {
    ORLABEL_PRODUCT.forEach(OR => {
    // X ∨ Y ∨ Z
    ANDARRAY_PRODUCT.push(SC_ManageGate.checkAllMustTrue(SidecartControl.checkAndArray('productcheck', OR, theme, producttyp, ipsproducttyp, button, addtocart_productid, cartItems)));
});
    }


    if (Array.isArray(ORLABEL_CART)) {
      ORLABEL_CART.forEach(OR => {
        // X ∨ Y ∨ Z
        ANDARRAY_CART.push(SC_ManageGate.checkAllMustTrue(SidecartControl.checkAndArray('cartcheck', OR, theme, producttyp, ipsproducttyp, button, addtocart_productid, cartItems)));
      });
    }



if (!SC_ManageGate.checkMinOneTrue(ANDARRAY_PRODUCT)) {
  passed.passed_product = false;
}
if (!SC_ManageGate.checkMinOneTrue(ANDARRAY_CART)) {
  passed.passed_cart = false;
}


  //If cat is in sidecrt and orderbump check true - hidden orderbumps
  //console.log("Orderbump checker: ",noorderbumps);
  if(passed.passed_cart && noorderbumps){
   // console.log("Handle orderbump");
      SidecartControl.handle_orderbumps_in_sidecart();
    }else{
    // console.log("No Handle orderbump");
    }



  if(controldirection === 'whitelist'){
  // Endergebnis ermitteln: Äquivalenz von passed_product und passed_cart
  //console.log("Whitelistmodus");
  passed.passed = (passed.passed_product === passed.passed_cart);
  }else{
  //  console.log("Blacklistmodus");
  //passed.passed = passed.passed_product && passed.passed_cart;
  passed.passed = (passed.passed_product !== passed.passed_cart);
  }



}

// console.log("<><> FINAL PASSED <><>", passed);

    return passed;
  },





  checkAndArray: (product_cart_check, innerOr, theme, producttyp, ipsproducttyp, button, productid, cartitems) => {
 // console.log("ICHECK_AND_ARRAY: ",product_cart_check);
 // console.log("INNEROR: ",innerOr);
  const innerAndArray = []; // Array für die Ergebnisse
  var wholeOr = null;
  var inOut = null;
  var AND = null;

  if(product_cart_check === 'productcheck'){
      wholeOr = innerOr['ips-repeater-and-cartgate-product-selection'];
  }else{
      wholeOr = innerOr['ips-repeater-and-cartgate-cart-selection'];
  }
  //    console.log("WHOLEOR: ",wholeOr);
    
      
    

    wholeOr.forEach(and => {
      let switchand;
      if(product_cart_check === 'productcheck'){
      inOut = and['ips-mb-cartgate-product-inout-option'] || 'in';
      switchand = and['ips-mb-cartgate-product-select-option'];
      }else{
      inOut = and['ips-mb-cartgate-cart-inout-option'] || 'in'; 
      switchand = and['ips-mb-cartgate-cart-select-option'];
      }
      let result = false; // Standardwert für das Ergebnis
  
      switch (switchand) {
        case 'all':
          result = true; // Beispielhafte Logik, je nach Anforderung anpassen
          break;
        case 'spec_attributes':
          if(product_cart_check === 'productcheck'){
          result = SC_ManageGate.checkAttributes(and['ips-mb-cartgate-product-select-firstitem-attribute'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);
          }else{
          result = SC_ManageGate.checkAttributes(and['ips-mb-cartgate-cart-select-firstitem-attribute'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);         
          }
          break;
        case 'spec_categories':
          if(product_cart_check === 'productcheck'){
          result = SC_ManageGate.checkCategories(and['ips-mb-cartgate-product-select-firstitem-cats'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid, SidecartControl.serverproof, cartitems);
          }else{
          result = SC_ManageGate.checkCategories(and['ips-mb-cartgate-cart-select-firstitem-cats'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid, SidecartControl.serverproof, cartitems);            
          }
          break;
        case 'spec_producttype':
          if(product_cart_check === 'productcheck'){
          result = SC_ManageGate.checkProducttype(and['ips-mb-cartgate-product-validation-specproducttype'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid, SidecartControl.serverproof, cartitems);
          }else{
          result = SC_ManageGate.checkProducttype(and['ips-mb-cartgate-cart-validation-specproducttype'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid, SidecartControl.serverproof, cartitems);            
          }
          break;
        case 'spec_products':
          result = SC_ManageGate.checkProducts();
          break;
        case 'spec_stockstatus':
          if(product_cart_check === 'productcheck'){
          result = SC_ManageGate.checkStockStatus(and['ips-mb-cartgate-product-select-firstitem-stockstatus'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);
          }else{
          result = SC_ManageGate.checkStockStatus(and['ips-mb-cartgate-cart-select-firstitem-stockstatus'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);            
          }
          break;
        case 'spec_productcheck':
          if(product_cart_check === 'productcheck'){
          result = SC_ManageGate.checkProductCheck(and['ips-mb-cartgate-product-select-option'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);
          }else{
          result = SC_ManageGate.checkProductCheck(and['ips-mb-cartgate-cart-select-option'], product_cart_check, theme, producttyp, ipsproducttyp, button, productid);            
          }
          break;
        default:
          result = false;
          break;
      }
  
      // Ergebnis invertieren, wenn inOut 'not' ist
      if (inOut === 'not') {
        result = !result;
      }

    //  console.log("RESULT product: ",result);
  
      innerAndArray.push(result); // Ergebnis zum Array hinzufügen
    });
  
    return innerAndArray;
  },







  check_Restrictions:  async ({ productId, settings = null, cartslider = null, theme = null, baseurl = null, servercheck = null, cartItems = null, cartCount = null, producttyp, ipsproducttyp, button, alertCounter }) => {
   // console.log("Restriction loop checkrestriction ok");
   //const resultcheck = SidecartControl.checkSideCartConditions({
    let resultcheck = SidecartControl.checkSideCartConditions({
      productId: productId,
      producttyp: producttyp,
      ipsproducttyp: ipsproducttyp,
      button: button,
      settingsbox: settings,
      cartslider_tmp: cartslider,
      theme: theme,
      cartItems: cartItems,
      cartCount: cartCount,     //null front check , not null servercheck
    });


//--------------------------------------------------------------------------------------------------
//---------------------------- CHECK AJAX Shopping-Cart --------------------------------------------

//console.log("Settings: ",settings);
//console.log("Settings base url: ",window.location.origin);
//console.log("Do restriction check");
//console.log("Cartitems here: ",cartItems);
//console.log("Found something ",resultcheck);


  // Falls der Frontend-Warenkorb leer erscheint, hole zur Sicherheit die aktuellen Daten vom Server
  //if (!cartItems || (Array.isArray(cartItems) && cartItems.length === 0)) {
 /* if(resultcheck.passed && servercheck === 'on'){   //FALSE heißt es wurde ein fall gefunden
    console.log("Do Server restrict check");
    try {
      // Hier wird der PHP-Endpoint (z. B. ips_get_server_cart) über die WoocommerceAPI aufgerufen
      //const serverResponse = await WoocommerceAPI.getServerCart(window.location.origin);
      const serverResponse = await WoocommerceAPI.getServerCart(baseurl);
      //const serverResponse = WoocommerceAPI.getServerCart(baseurl);
      //console.log("Server Response: ",serverResponse);
      //console.log("Server Response cartitems: ",serverResponse.cartItems);
      // Falls Daten zurückkommen, aktualisiere cartItems und führe den Check erneut aus
      if (serverResponse && serverResponse.cartItems) {
        cartItems = serverResponse.cartItems;
        let cartCount = serverResponse.cartItems.metacartdata[0].quantityall;
        resultcheck = SidecartControl.checkSideCartConditions({
          productId,
          producttyp,
          ipsproducttyp,
          button,
          settingsbox: settings,
          cartslider_tmp: cartslider,
          theme: theme,
          cartItems: cartItems,
          cartCount: cartCount
        });
       // console.log("Resultcheck after Server response: ",resultcheck);
      }
    } catch (error) {
      console.error('Fehler beim Abrufen des Server-Warenkorbs:', error);
    }
  }
  */
 // }else{
 //   console.log("Rendundand check not necessary");
//  }

  

 
//------------------------------------------------------------------------------------------
//---------------------------- MESSAGE SETTINGS --------------------------------------------


/* let noticelead = settings[0]['ips-mb-cartgate-addon-leadtext'];
let noticemessage = settings[0]['ips-mb-cartgate-addon-noticetext'];
let noticecolor = settings[0]['ips-mb-cartgate-addon-noticecolor'];
let noticefontcolor = settings[0]['ips-mb-cartgate-addon-noticefontcolor'];
let noticebordercolor = settings[0]['ips-mb-cartgate-addon-noticebordercolor'];
let noticeimage = settings[0]['ips-mb-cartgate-addon-noticeimage']; */



let noticelead = settings['ips-mb-cartgate-addon-leadtext'];
let shownotice = settings['ips-mb-cartgate-showmessage'];
let noticemessage = settings['ips-mb-cartgate-addon-noticetext'];
let noticecolor = settings['ips-mb-cartgate-addon-noticecolor'];
let noticefontcolor = settings['ips-mb-cartgate-addon-noticefontcolor'];
let noticebordercolor = settings['ips-mb-cartgate-addon-noticebordercolor'];
let noticeimage = settings['ips-mb-cartgate-addon-noticeimage'];




//-------------------------------------------------------------------------------------------


  
    let html_result = `<div class='ips_alertnoteout'><div class='ips_alertmessage error'><input type='checkbox' id='alert${alertCounter}'/><label class='close' style='`;
  
    if (resultcheck && Number(shownotice) === 1 && noticemessage) {
     
      if (noticefontcolor) {
        html_result += `color: ${noticefontcolor};`;
      }
  
      html_result += `' title='close' for='alert${alertCounter}'><i class='ips_icon-remove'></i></label><p class='inner'`;
  
      if (noticebordercolor) {
        html_result += ` style='border: 1px solid ${noticebordercolor};`;
      }
  
      if (noticecolor && noticecolor['color-1']) {
        html_result += `border-left: 5px solid ${noticecolor['color-1']};`;
      }
  
      if (noticecolor && noticecolor['color-2']) {
        html_result += `background-color: ${noticecolor['color-2']};`;
      }
  
      if (noticefontcolor) {
        html_result += `color: ${noticefontcolor};`;
      }
  
      html_result += `'>`;
  
      if (noticeimage && noticeimage != "" && noticeimage.url != "") {
        html_result += `<img src='${noticeimage.url}' class='ips_imagefrontnotice' alt='Your Image' style='vertical-align: middle;'> `;
      }
  
      html_result += `<strong>${noticelead} </strong>`;
      html_result += `${noticemessage}</p></div></div>`;
    } else {
      html_result += `>No message found.</p>`;
    }

/*
    if (!resultcheck.passed && SidecartControl.noticeElementRef) {
      // Erstelle einen eindeutigen Schlüssel, z. B. aus Lead und Nachricht
      let messageKey = noticelead + noticemessage;
    
      // Initialisiere das Property falls nicht vorhanden
      if (!SidecartControl.shownMessages) {
        SidecartControl.shownMessages = {};
      }
  
   // console.log("Message now 1");
  // Nur anzeigen, wenn die Nachricht noch nicht ausgegeben wurde
  if (!SidecartControl.shownMessages[messageKey]) {
   //   console.log("Message now 2");
      SidecartControl.noticeElementRef.innerHTML += html_result;
      SidecartControl.shownMessages[messageKey] = true;
      alertCounter++;
      window.scrollTo(0, 0);
    }
  }*/


     // console.log("Message now 1");
     if (!resultcheck.passed && SidecartControl.noticeElementRef) {
         //console.log("Message now out");
         SidecartControl.noticeElementRef.innerHTML += html_result;
         alertCounter++;
         window.scrollTo(0, 0);
       }else{
        //console.log("NO -- Message out");
       }
         
  
    return resultcheck;
  },











  check_RestrictionsLoop: async ({ productId, producttyp, ipsproducttyp, button, settings = null, cartItems = null }) => {
    //console.log("Restriction loop start");
    SidecartControl.setNoticeElementRef(document.getElementById('ips_label_notice'));
    if (SidecartControl.noticeElementRef) {
      // Lösche den vorhandenen Inhalt
      SidecartControl.noticeElementRef.innerHTML = '';
    }
    let restrictcheck = true;
    let alertCounter = 1;
    let cartCount = null;
  
    // Zuerst alle Optionen prüfen
    if (Array.isArray(settings.cartgateoptions)) {
      for (const setting of settings.cartgateoptions) {
        if (setting && typeof setting === 'object' && Object.keys(setting).length > 0) {
          let resultcheck = await SidecartControl.check_Restrictions({
            productId,
            settings: setting,
            cartslider: settings.cartslider,
            theme: settings.selecttcarttheme,
            baseurl: settings.base_url,
            servercheck: settings.cartcheckfallback, // Dieser Parameter signalisiert, ob ein Fallback erlaubt ist
            cartItems,
            cartCount,
            producttyp,
            ipsproducttyp,
            button,
            alertCounter,
          });
          if (resultcheck.passed === false) {
            restrictcheck = false;
          }
          alertCounter++;
        }
      }
    } else {
     // console.log("NO loop done");
    }
  
    // Falls alle Prüfungen bestanden wurden und der Fallback aktiviert ist,
    // führe den Server-Check aus – aber erneut über check_Restrictions, damit auch hier Notices ausgegeben werden.
    if (restrictcheck === true && settings.cartcheckfallback === 'on') {
      console.log("Performing server check fallback");
      try {
        const serverResponse = await WoocommerceAPI.getServerCart(settings.base_url);
        if (serverResponse && serverResponse.cartItems) {
          cartItems = serverResponse.cartItems;
          let cartCount = serverResponse.cartItems.metacartdata[0].quantityall;
          // Nun: Erneute Prüfung aller Optionen – diesmal ohne weitere Server-Checks (servercheck deaktiviert)
          let serverFallbackResult = true;
          for (const setting of settings.cartgateoptions) {
            if (setting && typeof setting === 'object' && Object.keys(setting).length > 0) {
              let result = await SidecartControl.check_Restrictions({
                productId,
                settings: setting,
                cartslider: settings.cartslider,
                theme: settings.selecttcarttheme,
                baseurl: settings.base_url,
                servercheck: 'off', // Deaktiviert den erneuten Server-Fallback, um eine Endlosschleife zu vermeiden
                cartItems,
                cartCount,
                producttyp,
                ipsproducttyp,
                button,
                alertCounter,
              });
              if (result.passed === false) {
                serverFallbackResult = false;
              }
            }
          }
          if (serverFallbackResult === false) {
            restrictcheck = false;
          }
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Server-Warenkorbs:', error);
      }
    }
  
    return restrictcheck;

  },










handle_orderbumps_in_sidecart: () => {

  var elementCFW = document.getElementById('cfw_order_bumps_below_cart_items');
  var elementIPS = document.getElementById('ips_order_bumps_below_cart_items');


  if (elementCFW) {
   // console.log("HIT IT");
    elementCFW.classList.add('hiddenaddcartgate');

  }

  if (elementIPS) {
    // Klassen 'hidden' und 'hiddenaddcartgate' hinzufügen
    elementIPS.classList.add('hidden', 'hiddenaddcartgate');
  }
      
  
},








saveCartToLocalStorage: ({ cartItems, supportsHTML5Storage }) => {
 // console.log("Will save localstorage 2");

 /*
  if (supportsHTML5Storage) {

    // Speichern im LocalStorage
    localStorage.setItem('ips_cart_items', JSON.stringify(cartItems));
    // Speichern im SessionStorage
    sessionStorage.setItem('ips_cart_items', JSON.stringify(cartItems));
  }*/
},






destroySidecart: (event) => {
console.log("<><> DESTROY SIDECART <><>");
event.preventDefault();
//event.stopImmediatePropagation();

},


destroyShopSidecart: (event) => {
  console.log("<><> DESTROY SHOP SIDECART <><>");
  event.preventDefault();
  event.stopImmediatePropagation();
  
  },

implementSidecart: () => {
  console.log("<><> IMPLEMENT SIDECART <><>");
  
  },




  checkSomething2: ({ settings }) => {
    // Hier die Logik für checkSomething2 mit settings...
  },
  checkSomething3: ({ settings }) => {
    // Hier die Logik für checkSomething3 mit settings...
  },
};

export default SidecartControl;